export const Color = {
  jaune: "#FCAE3B",
  bleu: "#28348a",
  vert: "#1AA981",
  themeColor: "#4BE1B4",
  success: "#1AA981",
  default: "#9203D7",
  white: "#fff",
  rouge: "#F45B5B",
};